<template>
  <div>
    <div id="entitySkillPopover" class="legends-popover entity_skill_popover"></div>
    <b-popover ref="creditProgressPopover" container="entitySkillPopover" :target="creditProgressTargetId" :show.sync="$parent.showCreditProgressPopup" :no-fade="true" triggers="click" :placement="'right'">
      <template v-slot:title>
		    <div class="header-content-row program">
          <span class="title">Required {{headerLabel}} as of {{lastUpdatedDateTime(progress)}}</span>
            <button class="btn_close" aria-label="close" @click="closeCreditProgressPopup">
              <span class="ic-close"></span>
            </button>
        </div>
      </template>

      <div class="text-center"><span class="title"><strong>{{title}}</strong></span></div>
        <template v-show="isPieChartGenerated">
          <div class="popup_grph">
            <div class="skill_chart program_credit" id="creditProgressChart"></div>
            <div class="skilllegend_detail">
              <template v-if="isWidget">
                <div class="status_row" style="margin-top: 68px;"><span class="lg_blc credits_selected" style="background-color: #532a6e;"></span>Selected {{legendSuffix}}</div>
                <div class="status_row"><span class="lg_blc completed"></span>Completed {{legendSuffix}}</div>
                <div class="status_row"><span class="lg_blc credits_needed"></span>Missing {{legendSuffix}}</div>
              </template>
              <template v-else>
                <div class="status_row"><span class="lg_blc transferred"></span>Transferred {{legendSuffix}}</div>
                <div class="status_row"><span class="lg_blc completed"></span>Completed {{legendSuffix}}</div>
                <div class="status_row"><span class="lg_blc in_progress"></span>In Progress {{legendSuffix}}</div>
                <div class="status_row"><span class="lg_blc in_the_plan"></span>In the Plan {{legendSuffix}}</div>
                <div class="status_row"><span class="lg_blc credits_needed"></span>{{creditLabel}}s Needed {{legendSuffix}}</div>
              </template>
            </div>
          </div>
        </template>
	    <div class="popup-footer">
        <div class="updated_time" v-if="!isWidget" style="margin-top: 0;">
          <div v-if="isShowTransferredCourseLink" class="mb-2 text-center">
            <i><a href="javascript://" @click="navigateToDegreeRequirementsView" style="font-size: 16px;">View {{transferredCoursesLabel}}</a></i>
          </div>
          <div>
            <span style="font-size: 16px;">
              <i>Please contact your advisor for the exact program requirements and transferable courses.</i>
            </span>
          </div>
        </div>

        <div class="updated_time">
          <span class="ico-error" v-if="isTimeDifference"></span>
          <span class="sec_txt">Last Calculated On {{lastUpdatedDateTime(progress)}}</span>
        </div>

        <div class="calculate_btn" style="margin-left: 58px;">
          <button class="btn btn-primary" @click="recalculateCreditProgress">Re-calculate now</button>
        </div>
		  </div>

      <div class="loading-spinner">
        <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
          <div class="text-center" style="color: #FFF; overflow: hidden; height: 100%; width:100%;">
            <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
          </div>
        </b-modal>
      </div>
    </b-popover>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import moment from 'moment'
  import { PACKAGE } from '../../../package_constants'
  import * as d3 from 'd3'

  export default {
    name: 'explore-program-credit-progress',
    props: ['title', 'programId', 'streamId', 'creditProgressTargetId', 'isWidget', 'selected'],
    data: () => {
      return {
        progress: null,
        programGuide: null,
        isPieChartGenerated: false
      }
    },
    async created () {
      this.programGuide = await this.loadProgramGuideByUuid(this.programId)
      await this.loadCreditProgress(false)
    },
    updated () {
      this.$nextTick(() => {
        if (this.progress) {
          if (this.isShowCourseProgressEnabled) {
            let colorScale = {
              'transferred courses': '#56b5e8',
              'completed courses': '#5c8c43',
              'in progress courses': '#aac76b',
              'scheduled courses': '#f5b318',
              'courses needed': '#cf7908'
            }
            if (this.isWidget) {
              colorScale['courses selected'] = '#532a6e'
            }
            this.generatePieChart(this.progress.courseValues, colorScale, 'creditProgressChart')
          } else {
            let colorScale = {
              'transferred': '#56b5e8',
              'completed': '#5c8c43',
              'in progress': '#aac76b',
              'scheduled': '#f5b318',
              'credits needed': '#cf7908'
            }
            if (this.isWidget) {
              colorScale['credits selected'] = '#532a6e'
            }
            this.generatePieChart(this.progress.values, colorScale, 'creditProgressChart')
          }
        }
      })
    },
    methods: {
      ...mapActions([
        'loadProgramGuideByUuid',
        'loadProgramCreditProgress',
        'loadUpdateCourseProgramProgress'
      ]),
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      closeCreditProgressPopup () {
        this.$parent.creditProgressTargetId = ''
        this.$parent.selectedProgramGuide = null
        this.$parent.showCreditProgressPopup = false
      },
      loadCreditProgress (isRecalculate) {
        this.showLoader()
        this.isPieChartGenerated = false
        this.loadProgramCreditProgress({streamId: this.streamId, programId: this.programId, recalculate: isRecalculate}).then(res => {
          this.progress = res
          if (this.isWidget) {
            this.addSelectedCourseCreditForWidget()
          }
          setTimeout(() => {
            this.hideLoader()
          }, 500)
        })
      },
      addSelectedCourseCreditForWidget () {
        this.progress.values.push({label: 'credits selected', value: this.selected})
        this.progress.values.forEach((progress, x) => {
          if (progress.label === 'credits needed') {
            progress.value -= this.selected
          }
        })
        this.progress.courseValues.push({label: 'courses selected', value: this.selected})
        this.progress.courseValues.forEach((progress, y) => {
          if (progress.label === 'courses needed') {
            progress.value -= this.selected
          }
        })
      },
      generatePieChart (data, colorScale, elementId) {
        $('#' + elementId).empty()
        var pieChartContainerHeight = 250
        var pieChartInnerRadius = 60
        var width = pieChartContainerHeight
        var height = pieChartContainerHeight
        var radius = pieChartContainerHeight / 2

        var canvas = d3.select('#' + elementId).append('svg')
                     .data([data]).attr('width', width).attr('height', height).append('g')
                     .attr('transform', 'translate(' + radius + ',' + radius + ')')

        var arc = d3.arc()
                  .outerRadius(radius)
                  .innerRadius(pieChartInnerRadius)

        var pie = d3.pie()
                  .value(function (d) { return d.value }).sort(null)

        var arcs = canvas.selectAll('.arc')
                   .data(pie(data))
                   .enter().append('g')
                   .attr('class', 'arc')

        arcs.append('path')
            .attr('d', arc)
            .style('fill', function (d, i) { return colorScale[d.data.label] })

        arcs.append('text')
            .attr('transform', function (d) { return 'translate(' + arc.centroid(d) + ')' })
            .style('font', 'bold 12px Arial')
            .style('fill', '#fff')
            .style('cursor', 'default')
            .attr('text-anchor', 'middle')
            .text(function (d) { return d.data.value })

        this.isPieChartGenerated = true
      },
      changeMillisToDate (millis, format) {
        return DateTime.fromMillis(millis, {zone: 'utc'}).toFormat(format)
      },
      lastUpdatedDateTime (progress) {
        return (progress) ? this.changeMillisToDate(progress.lastUpdatedTime, 'MM/dd/yyyy @ hh:mm a') : ''
      },
      currentDateTime (progress) {
        let millis = moment().valueOf()
        if (progress && progress.currentTime) {
          millis = progress.currentTime
        }
        return this.changeMillisToDate(millis, 'MM/dd/yyyy (hh:mm a)')
      },
      recalculateCreditProgress () {
        if (this.isWidget) {
          this.updateCreditProgressForWidget()
        } else {
          this.loadCreditProgress(true)
        }
      },
      updateCreditProgressForWidget () {
        this.loadUpdateCourseProgramProgress({streamId: this.streamId, programId: this.programId}).then(res => {
          this.progress = res
          this.addSelectedCourseCreditForWidget()
        })
      },
      navigateToDegreeRequirementsView () {
        return this.$router.push({name: 'programGuideDegreeRequirements', params: this.programGuideRouterParams})
      }
    },

    computed: {
      ...mapState({
        'enabledFeatures': state => state.institution.enabledFeatures
      }),
      headerLabel () {
        return this.isShowCourseProgressEnabled ? 'Courses' : this.creditLabel + 's'
      },
      creditLabel () {
        let creditLabelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CUSTOM_CREDIT_LABEL_FEATURE_ID]
        if (!creditLabelFeature || !creditLabelFeature.enabled || !creditLabelFeature.label) {
          return 'Credit'
        }
        return creditLabelFeature.label
      },
      legendSuffix () {
        return this.isShowCourseProgressEnabled ? 'Courses' : ''
      },
      isShowCourseProgressEnabled () {
        let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
        if (progressViewFeature && progressViewFeature.enabled) {
          let flags = progressViewFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCourseProgress' || flags[i].title === 'showCourseProgressOnOverall') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      isShowCreditProgressEnabled () {
        let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
        if (progressViewFeature && progressViewFeature.enabled) {
          let flags = progressViewFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCreditProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      isTimeDifference () {
        if (this.progress) {
          let curr = Math.floor(this.progress.currentTime / 60000)
          let last = Math.floor(this.progress.lastUpdatedTime / 60000)
          return ((curr - last) > 0)
        }
        return true
      },
      programGuideRouterParams () {
        let routerParams = {
          cipCode: this.programGuide.cipCode,
          programGuideCode: this.programGuide.code,
          type: this.programGuide.type,
          returnTo: 'exploreProgramGuideResults',
          showBackToResultButton: true,
          isExpandTransferredCourses: true
        }
        return routerParams
      },
      transferredCoursesLabel () {
        let lable = 'Transferred Courses'
        let transferCoursesFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TRANSFER_PREVIOUS_COURSES_FEATURE_ID]
        if (transferCoursesFeature && transferCoursesFeature.enabled) {
          let flags = transferCoursesFeature.flags
          for (let i = 0; i < flags.length; i++) {
            let flag = flags[i]
            if ((flag.title === 'showTransferredCoursesOnDegreeRequirement') && flag.label.length > 0) {
              lable = flag.label
            }
          }
        }
        return lable
      },
      isShowTransferredCourseLink () {
        if (this.$route.name !== 'programGuideDegreeRequirements') {
          return (this.progress && this.progress.transfered)
        }
        return false
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreProgramCreditProgress.vue